const IconArrowDown = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.675 4.875L7.5 8.69167L11.325 4.875L12.5 6.05L7.5 11.05L2.5 6.05L3.675 4.875Z"
      fill="#736967"
    />
  </svg>
);

export default IconArrowDown;
